import { SESSION_READY, END_TURN, NEW_TURN, GAMEOVER, SETTED_BUFF, SPEED_LINE } from './consts';
import { GAME_CHECK_DEF_HIT } from './gameutils';
import { cloneDeep } from 'lodash';

const defPersProps = [
    'race', 'lives', 'name', 'force'
]
const defPers1Props = [
]
const defPers2Props = [
]


export default class NggGameEngine {

    constructor(props) {

        const {
            messageEndpoint,
            getExtraSlots
        } = props;

        this.messageEndpoint = (message, props = null) => messageEndpoint(message, props);
        this.getExtraSlots = () => getExtraSlots();
        //this.textEndpoint = (props) => textEndpoint(props);

        this.Story = [];

        this.Pers1 = {};
        this.Pers2 = {};

        this.nowBlockMoveNumber = 1;
        this.nowMoveNumber = 1;

        this.gamePhase = 'waiting'; // going ended
        this.gameResult = {};
    }

    definePers1 = (innerName, props) => {
        this[innerName] = { ...props };

        this[innerName].innerLives = props.innerLives || props.lives;
        this[innerName].innerProps = { ...props };

        this[innerName].adders = {};

        // defPersProps.forEach(key => {
        //     if (props[key]) this[innerName][key] = props[key];
        // })
        // defPers1Props.forEach(key => {
        //     if (props[key]) this[innerName][key] = props[key];
        // })

    }

    definePers2 = (innerName, props) => {
        this[innerName] = { ...props };
        this[innerName].innerLives = props.lives;
        this[innerName].innerProps = { ...props };

        this[innerName].adders = {};
        // defPersProps.forEach(key => {
        //     if (props[key]) this[innerName][key] = props[key];
        // })
        // defPers2Props.forEach(key => {
        //     if (props[key]) this[innerName][key] = props[key];
        // })
    }

    startSession = (props) => {
        const { Pers1, Pers2, InnerBlock, conditions } = props;

        delete this.Pers1;
        this.Pers1 = null;
        this.Pers1 = {};
        this.conditions = { ...conditions };

        delete this.Pers2;
        this.Pers2 = null;
        this.Pers2 = {};

        this.definePers1('Pers1', Pers1);
        this.definePers2('Pers2', Pers2);

        const {
            scheme, // [1, 2, 2]
            type
        } = InnerBlock

        this.nowBlockMoveNumber = 1;
        this.nowMoveNumber = 1;

        this.InnerBlock = InnerBlock;
        this.NowBlock = scheme;

        this.gamePhase = 'going';
        this.messageEndpoint(SESSION_READY)
    }

    get nowMoveStats() {
        const { Pers1, Pers2, NowBlock, nowBlockMoveNumber, nowMoveNumber } = this;
        return {
            Pers1, Pers2, NowBlock, nowBlockMoveNumber, nowMoveNumber
        }
    }

    get whosTurn() {
        const { NowBlock, nowBlockMoveNumber } = this;
        return NowBlock[nowBlockMoveNumber - 1] === 1 ? 'Pers1' : 'Pers2';
    }

    // это получить 
    Pers2SpeedTo1 = () => {
        let shift = 0;
        let endAttackSpeed = this.PersAdderParam(2, 'attackInner');
        const vigilance = this.PersAdderParam(1, 'vigilance') || 0;
        const attackSpeed = this.PersAdderParam(2, 'attackSpeed');
        const attackGreedLeft = this.PersAdderParam(2, 'attackGreedLeft');
        const attackGreedRight = this.PersAdderParam(2, 'attackGreedRight');

        if (vigilance > attackSpeed) {
            shift += Math.floor((vigilance - attackSpeed) / attackGreedRight);
        }
        if (vigilance < attackSpeed) {
            shift -= Math.floor((attackSpeed - vigilance) / attackGreedLeft);
        }

        endAttackSpeed += shift;

        if (endAttackSpeed < 0) { endAttackSpeed = 0 }
        if (endAttackSpeed >= (SPEED_LINE.length)) { endAttackSpeed = SPEED_LINE.length - 1 }

        return endAttackSpeed;

    }

    timeToTninkPers1 = () => {
        const whosTurn = this.whosTurn;
        const endAttackSpeed = this.Pers2SpeedTo1();

        if (whosTurn === 'Pers1') {
            // пока что
            if (endAttackSpeed === 0) {
                return 1;
            }
            if (endAttackSpeed === 1) {
                return 5;
            }
            return 0;
        }

        const {
            thinkBaseTime, thinkSlow
        } = SPEED_LINE[endAttackSpeed];

        const timeToThink = thinkBaseTime + Math.floor((Math.random() - 0.0000005) * thinkSlow);
        return timeToThink;
    }

    isGameOver = () => {
        const { Pers1, Pers2 } = this;
        if (Pers1.lives <= 0) return this.messageEndpoint(GAMEOVER, { message: 'закончились жизни', dead: Pers1 })
        if (Pers2.lives <= 0) return this.messageEndpoint(GAMEOVER, { message: 'закончились жизни', dead: Pers2 })
    }

    // Это основной функционал - кто-то делает ход в том контексте, который есть
    makeMove = (props) => {
        const { Pers1, Pers2 } = props;

        // console.log('makeMove');

        let actions1 = Pers1.actions || [];
        let actions2 = Pers2.actions || [];

        if (this.isThereBuff({ persNumber: 1, buff: 'sbiv' })) {
            if (actions1 && actions1[0] && actions1[0].type === 'strike' && actions1[0].point === 2
                && (!this.Pers2.armorType[2].uppers || !this.Pers2.armorType[2].uppers.find(x => (x.type === 'shield' && x.hp > 0)))
            ) {
                actions2 = [];
            } else {
                actions1 = [];
            }
        }

        let localStory = [];

        // тут надо понять, кто по кому попал и куда, просто факт попадания
        let hitResults = [];
        const resultOfHit = (agressorNumber, agressor, agressorAction, victim) => {
            const { point } = agressorAction;

            // тут могут быть спец случаи, почему что-то является неуязвимым

            // смотрим че по защите
            const victimAction = (victim.actions || []).find(x => x.type === 'defence' && x.point === point);
            if (!victimAction) {
                return hitResults.push({
                    agressorNumber,
                    agressor,
                    victim,
                    point,
                    agressorAction,
                    victimAction: null
                })
            } else {
                return hitResults.push({
                    agressorNumber,
                    agressor,
                    victim,
                    point,
                    agressorAction,
                    victimAction
                })
            }

        }

        // попадания
        actions2.forEach(x => x.type === 'strike' && resultOfHit(2, { ...this.Pers2, ...Pers2 }, x, { ...this.Pers1, ...Pers1 }));
        let lookedFor1 = true;
        if (this.isThereBuff({ persNumber: 1, buff: 'contra' })) {
            // тут надо проверить - не попали ли по нам в этом ходу
            // иначе первого вообще не смотрим, чё он там делал
            if (hitResults.find(x => (x.agressorNumber === 2 && !x.victimAction))) {
                lookedFor1 = false;
            }
        }


        lookedFor1 && actions1.forEach(x => x.type === 'strike' && resultOfHit(1, { ...this.Pers1, ...Pers1 }, x, { ...this.Pers2, ...Pers2 }));

        // теперь начинаем разбирать по попаданиям, что именно нужно сделать

        // применяет баффы на основе попадания
        this.buffHitProcessor(hitResults);
        this.extrasPassiveProcessor();

        hitResults.forEach(hit => {

            const { agressorNumber,
                agressor,
                victim,
                point,
                agressorAction,
                victimAction } = hit;

            if (!victimAction) {
                const story = this.hitProcessor(hit);
                localStory.push({
                    action: 'hit',
                    agressor,
                    victim,
                    point,
                    agressorAction,
                    ...story
                })
            } else {
                localStory.push({
                    action: 'miss',
                    agressor,
                    victim,
                    point,
                    agressorAction
                })
            }
        })


        this.buffInner({ persNumber: 1, action: 'removeleft' })
        this.buffInner({ persNumber: 2, action: 'removeleft' })

        this.conditionsProcessor();

        this.buffProcessor({ persNumber: 1 });
        this.buffProcessor({ persNumber: 2 });

        this.buffInner({ persNumber: 1, action: 'removeleft' })
        this.buffInner({ persNumber: 2, action: 'removeleft' })


        this.messageEndpoint(END_TURN, { localStory })
        this.isGameOver();

    }

    // CONDITIONS

    conditionsProcessor = () => {
        const { conditions } = this;

        if (!conditions) return;

        const keys = Object.keys(conditions);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];

            if (key === 'cold') {
                const { lvl, dpl } = conditions[key];

                // мы будем накладывать единичный бафф урона
                const defcold = this.PersAdderParam(1, 'defcold');
                const force = Math.max(0, (lvl - defcold) * dpl);
                if (force && force > 0)
                    this.buffInner({
                        persNumber: 1, action: 'add', buff: {
                            id: Math.floor(Math.random * 1000000),
                            type: 'cold',
                            innerLeft: 1,
                            force,
                            immediately: true
                        }
                    })

            }

        }

    }

    // BUFFS AND ADDERS PARAMS

    setBuffParam = (persNumber, buffId, paramName, paramValue) => {
        const { buffs = [] } = this[`Pers${persNumber}`];
        for (let i = 0; i < buffs.length; i++) {
            const { id } = buffs[i];
            if (id === buffId) {
                this[`Pers${persNumber}`].buffs[i][paramName] = paramValue;
            }
        }
    }

    isThereBuff = ({ persNumber, buff }) => this[`Pers${persNumber}`].buffs && this[`Pers${persNumber}`].buffs.length && this[`Pers${persNumber}`].buffs.find(x => x.type === buff);
    isThereBuffs = ({ persNumber, buff }) => this[`Pers${persNumber}`].buffs && this[`Pers${persNumber}`].buffs.length && this[`Pers${persNumber}`].buffs.filter(x => x.type === buff);

    // это штука на основе попадание применяет те или иные баффы
    // т.е. если было попадание и при этом был какой-то бвфф на персе (пока только от 1 к 2)
    buffHitProcessor = (hitResults) => {

        // наполняем триплпопадания
        const triple = this.isThereBuff({ persNumber: 1, buff: 'triple' });

        if (triple) {
            const hit = hitResults.find(x => (x.agressorNumber === 1 && !x.victimAction));
            if (hit) {
                let fulled = triple.fulled;
                if (!fulled) fulled = {};
                fulled[hit.point] = 1;
                this.setBuffParam(1, triple.id, 'fulled', fulled);
            }

            const tripleNew = this.isThereBuff({ persNumber: 1, buff: 'triple' });
            if (tripleNew && tripleNew.fulled && tripleNew.fulled[1] && tripleNew.fulled[2] && tripleNew.fulled[3]) {
                if (hit) {
                    // удаляем сам трипл, добавляем дебафф
                    const { point } = hit;
                    const { hitBuffs } = tripleNew;
                    if (hitBuffs && hitBuffs[point]) {
                        this.buffInner({ persNumber: 1, action: 'add', buff: { ...hitBuffs[point], id: Math.floor(Math.random * 1000000) } })
                    }
                    this.buffInner({ persNumber: 1, action: 'remove', buff: 'triple' })

                }
            }
        }

        const ectangle = this.isThereBuff({ persNumber: 1, buff: 'ectangle' })
        if (ectangle) {
            if (hitResults.find(x => (x.agressorNumber === 1 && x.point === 3 && !x.victimAction))) {
                const { resultBuff } = ectangle;
                this.buffInner({ persNumber: 2, action: 'add', buff: { ...resultBuff } })
                this.buffInner({
                    persNumber: 1, action: 'add', buff: {
                        ...ectangle,
                        id: Math.floor(Math.random * 1000000),
                        type: 'strength'
                    }
                })
            }

        }

    }

    extrasPassiveProcessor = () => {
        const extras = this.getExtraSlots();
        for (let i = 0; i < extras.length; i++) {
            const extra = extras[i];
            if (extra.passiveBuff) {
                this.buffInner({ persNumber: 1, action: 'add', buff: { id: Math.floor(Math.random * 1000000), ...extra.passiveBuff } })
            }
        }
    }

    PersAdderParam = (persNumber, paramName) => {
        const Pers = this[`Pers${persNumber}`];
        if (!Pers[paramName]) return 0;

        let adder = 0;
        if (Pers.adders && Pers.adders[paramName]) adder = Pers.adders[paramName];

        return Pers[paramName] + adder;
    }

    // добавить в adder значение
    AdderParamProcessor = (persNumber, paramName, value) => {
        if (!this[`Pers${persNumber}`].adders) this[`Pers${persNumber}`].adders = {};
        if (!this[`Pers${persNumber}`].adders[paramName]) this[`Pers${persNumber}`].adders[paramName] = 0;

        this[`Pers${persNumber}`].adders[paramName] += value;
    }

    // add / remove // removeleft // removeall
    // если remove - мы передаём в buff тип
    buffInner = ({ persNumber, buff, action = 'add' }) => {
        if (!this[`Pers${persNumber}`]) return;
        if (!this[`Pers${persNumber}`].buffs) this[`Pers${persNumber}`].buffs = [];

        let bufEvent = null;

        if (action === 'add') {
            const allrBuff = this[`Pers${persNumber}`].buffs.find(x => x.id === buff.id);
            if (allrBuff) {
                const { id } = allrBuff;
                this.removeBuffStats({ persNumber, id });
                this[`Pers${persNumber}`].buffs = this[`Pers${persNumber}`].buffs.reduce((memo, val) => { return (val.id === id) ? [...memo] : [...memo, val] }, [])
            }

            this[`Pers${persNumber}`].buffs.push({ ...buff, left: buff.innerLeft });
            if (buff.immediately) {
                const res = this.buffProcessor({ persNumber, buffId: buff.id });
                if (res) {
                    bufEvent = { event: 'buffAdded', persNumber, buff }
                }
            }
        }

        if (action === 'remove' && this[`Pers${persNumber}`].buffs.find(x => x.type === buff)) {
            this[`Pers${persNumber}`].buffs = this[`Pers${persNumber}`].buffs.reduce((memo, item) => {
                if (item.type === buff) { this.removeBuffStats({ persNumber, id: item.id }); return memo };
                return [...memo, item]
            }, [])
        }

        // это значит проверить те, которые должны закончиться
        if (action === 'removeleft') {
            const newBuffs = this[`Pers${persNumber}`].buffs.reduce((memo, item) => {
                if (item.left <= 0) {
                    this.removeBuffStats({ persNumber, id: item.id });
                    return memo;
                };
                return [...memo, item]
            }, [])
            this[`Pers${persNumber}`].buffs = newBuffs;
        }

        if (action === 'removeall') {
            this[`Pers${persNumber}`].buffs = [];
        }

        this.messageEndpoint(SETTED_BUFF, bufEvent);
    }

    // бафф прошел, что именно нам нужно сделать (например, вернуть какой-то параметр)
    removeBuffStats = ({ persNumber, id }) => {
        const buff = this[`Pers${persNumber}`].buffs.find(x => x.id === id);
        if (!buff) return;
        switch (buff.type) {
            case 'sn_speed': {
                const { addedSpeed } = buff;
                this.AdderParamProcessor(persNumber, 'attackInner', -addedSpeed);
                break;
            }
            case 'ectangled': {
                const { addedSpeed, adderForce } = buff;
                !!addedSpeed && this.AdderParamProcessor(persNumber, 'attackInner', -addedSpeed);
                !!adderForce && this.AdderParamProcessor(persNumber, 'force', -adderForce);
                break;
            }

            // armorType: {
            //     1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
            //     2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] },
            //     3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] }
            // },

            case 'sn_spices': {
                const { spicesAt = [] } = buff;
                spicesAt.forEach(point => {
                    this[`Pers${persNumber}`].armorType[point].uppers = this[`Pers${persNumber}`].armorType[point].uppers.reduce(
                        (memo, val) => {
                            if (val.type === 'spices') return [...memo]
                            return [...memo, val];
                        },
                        []
                    )
                })
            }
            default: {
            }
        }


    }

    // это процессор баффов (одного или нескольких)
    buffProcessor = ({ persNumber, buffId = null }) => {
        const buffs = this[`Pers${persNumber}`].buffs;
        if (!buffs || !buffs.length) return false;

        let doBuffAnimation = true;

        const processOneBuff = (buff, index) => {
            if (buff.useOnlyAtStart && buff.left !== buff.innerLeft) return false;
            if (buff.immediately && buff.immediatelyDone) return false;
            switch (buff.type) {
                case 'heal': {
                    // тут будем смотреть по карточкам что как
                    const { heal = 0 } = buff;

                    if (this[`Pers${persNumber}`].lives >= this[`Pers${persNumber}`].innerLives) {
                        doBuffAnimation = false;
                    }

                    this[`Pers${persNumber}`].lives += heal;
                    if (this[`Pers${persNumber}`].lives > this[`Pers${persNumber}`].innerLives) {
                        this[`Pers${persNumber}`].lives = this[`Pers${persNumber}`].innerLives
                    }
                    break;
                }
                case 'cold': {
                    const { force } = buff;
                    this[`Pers${persNumber}`].lives -= force;
                    break;
                }
                case 'sn_speed': {
                    const { speedTo, speedShift } = buff;
                    if (speedTo !== undefined) {
                        const addedSpeed = this[`Pers${persNumber}`].attackInner - speedTo;
                        this.AdderParamProcessor(persNumber, 'attackInner', addedSpeed);
                        // addedSpeed - сколько вносит конкретный БАФФ
                        if (!this[`Pers${persNumber}`].buffs[index].addedSpeed) this[`Pers${persNumber}`].buffs[index].addedSpeed = 0;
                        this[`Pers${persNumber}`].buffs[index].addedSpeed += addedSpeed;
                    }
                    if (speedShift !== undefined) {
                        this.AdderParamProcessor(persNumber, 'attackInner', speedShift);

                        // addedSpeed - сколько вносит конкретный БАФФ
                        if (!this[`Pers${persNumber}`].buffs[index].addedSpeed) this[`Pers${persNumber}`].buffs[index].addedSpeed = 0;
                        this[`Pers${persNumber}`].buffs[index].addedSpeed += speedShift;
                    }
                    break;
                }
                case 'ectangled': {
                    const { speedMinus, forcePercentMinus } = buff;
                    if (speedMinus !== undefined) {
                        this.AdderParamProcessor(persNumber, 'attackInner', speedMinus);

                        // addedSpeed - сколько вносит конкретный БАФФ
                        if (!this[`Pers${persNumber}`].buffs[index].addedSpeed) this[`Pers${persNumber}`].buffs[index].addedSpeed = 0;
                        this[`Pers${persNumber}`].buffs[index].addedSpeed += speedMinus;
                    }
                    if (forcePercentMinus !== undefined) {

                        const adderForce = -this[`Pers${persNumber}`].force * (forcePercentMinus / 100)
                        this.AdderParamProcessor(persNumber, 'force', adderForce);

                        if (!this[`Pers${persNumber}`].buffs[index].adderForce) this[`Pers${persNumber}`].buffs[index].adderForce = 0;
                        this[`Pers${persNumber}`].buffs[index].adderForce += adderForce;
                    }
                    break;
                }
                case 'sn_spices': {
                    const { spicesAt = [], damage } = buff;
                    spicesAt.forEach(point => {
                        if (!this[`Pers${persNumber}`].armorType[point].uppers.find(x => x.type === 'spices')) {
                            this[`Pers${persNumber}`].armorType[point].uppers.unshift(
                                { type: 'spices', damage }
                            );
                        }
                    })
                    break;
                }
                default: {
                    return false;
                }
            }

            if (doBuffAnimation && buff.innerLeft && buff.left && buff.innerLeft === buff.left && persNumber === 1) {
                const bufEvent = { event: 'buffAdded', persNumber, buff }
                this.messageEndpoint(SETTED_BUFF, bufEvent);
            }

            return true;

        }
        const shiftLeftOneBuff = (buff, i) => {
            if (this[`Pers${persNumber}`].buffs[i]) {

                if (buff.immediately && !buff.immediatelyDone) {
                    this[`Pers${persNumber}`].buffs[i].immediatelyDone = true;
                    return;
                }

                if (buff.leftType === 'my_move') {
                    if (this.whosTurn === `Pers${persNumber}`)
                        this[`Pers${persNumber}`].buffs[i].left--;
                } else {
                    this[`Pers${persNumber}`].buffs[i].left--;
                }
            }
        }

        let res = false;

        if (buffId) {
            const buff = this[`Pers${persNumber}`].buffs.find(x => x.id === buffId);
            if (buff) {
                const i = this[`Pers${persNumber}`].buffs.indexOf(buff);
                if (i !== undefined && i !== null) {
                    res = processOneBuff(buff, i);
                    shiftLeftOneBuff(buff, i)
                }
            }
        }
        else
            for (let i = 0; i < buffs.length; i++) {
                const buff = buffs[i];
                processOneBuff(buff, i);
                shiftLeftOneBuff(buff, i)
            }
        return res;

    }

    addPersExtrasStrategy = ({ persNumber, blockNum, buffId }) => {
        if (!this[`Pers${persNumber}`].extrasStrategy) this[`Pers${persNumber}`].extrasStrategy = {};
        if (!this[`Pers${persNumber}`].extrasStrategy[blockNum]) this[`Pers${persNumber}`].extrasStrategy[blockNum] = [];

        if (!this[`Pers${persNumber}`].extrasStrategy[blockNum].find(x => x === buffId))
            this[`Pers${persNumber}`].extrasStrategy[blockNum].push(buffId);
    }

    // удаляет поле из локальной стратегии на ход Снеговика
    removePersExtrasStrategy = ({ persNumber, blockNum }) => {
        if (!this[`Pers${persNumber}`].extrasStrategy) return null;
        this[`Pers${persNumber}`].extrasStrategy[blockNum] = null;
        delete this[`Pers${persNumber}`].extrasStrategy[blockNum];
    }

    // это когда вот уже прямо произошел удар точно
    hitProcessor = (hitStory) => {
        const { agressorNumber,
            agressor,
            victim,
            point,
            agressorAction,
            victimAction } = hitStory;

        const { race } = agressor;
        const { technics } = agressorAction;

        const force = Math.max(0, this.PersAdderParam(agressorNumber, 'force'));

        let target = '';
        let attacker = '';
        if (agressorNumber === 1) { target = 'Pers2'; attacker = 'Pers1' };
        if (agressorNumber === 2) { target = 'Pers1'; attacker = 'Pers2' };
        let addedState = {};

        if (race === 'player') {

            // выбираем силу удара
            let force_ = 0;
            const tech = agressor.technics.strike.find(x => x.key === technics);
            if (tech && tech.strength) force_ = force * tech.strength;

            let buffsStrength = this.isThereBuffs({ persNumber: 1, buff: 'strength' });
            if (buffsStrength && buffsStrength.length) {
                for (let i = 0; i < buffsStrength.length; i++)
                    force_ *= buffsStrength[i].strengthX;
            }

            if (!victim.armorType) {
                if (agressorNumber === 1) this.Pers2.lives -= force_;
                if (agressorNumber === 2) this.Pers1.lives -= force_;

                return { force: force_ };
            }

            if (victim.armorType && victim.armorType[point]) {
                const armor = victim.armorType[point];
                const { type, uppers } = armor;

                // сначала смотрим удовлетворение uppers
                if (uppers && uppers.length) {
                    for (let i = 0; i < uppers.length; i++) {
                        const upper = uppers[i];
                        const { type } = upper;

                        if (type === 'shield') {
                            const { innerHp, armorName } = upper;

                            // если уже меньше нуля, просто проходим мимо
                            if (this[target].armorType[point].uppers[i].hp <= 0) {

                            } else {
                                if ((this[target].armorType[point].uppers[i].hp - force_) <= 0) {
                                    addedState.event = { type: 'armorDestroyed' }
                                    this[target].armorType[point].uppers[i].hp -= force_;
                                    addedState.event.hp = this[target].armorType[point].uppers[i].hp;
                                    addedState.event.armorName = armorName;
                                    return { force: force_, ...addedState }
                                } else {
                                    addedState.event = { type: 'armorHitted', innerHp }
                                    this[target].armorType[point].uppers[i].hp -= force_;
                                    addedState.event.hp = this[target].armorType[point].uppers[i].hp;
                                    addedState.event.armorName = armorName;
                                    return { force: force_, ...addedState }
                                }
                            }
                        }

                        if (type === 'inner') {
                            if (GAME_CHECK_DEF_HIT.checkInner({ armorType: victim.armorType })) {
                                this[target].lives -= force_;
                            } else {
                                addedState.event = { type: 'noDamage' }
                            }
                            return { force: force_, ...addedState }
                        }

                        if (type === 'deflect') {
                            const { innerHp } = upper;
                            // уже была разбита, на этом заканчиваем
                            if (this[target].armorType[point].uppers[i].hp <= 0) {
                                addedState.event = { type: 'noDamage' }
                                return { force: force_, ...addedState }
                            }
                            if ((this[target].armorType[point].uppers[i].hp - force_) <= 0) {
                                addedState.event = { type: 'deflectDestroyed' }
                            } else {
                                addedState.event = { type: 'deflectHitted', innerHp }
                            }

                            this[target].armorType[point].uppers[i].hp -= force_;
                            addedState.event.hp = this[target].armorType[point].uppers[i].hp;

                            return { force: force_, ...addedState }
                        }

                        if (type === 'spices') {
                            const { damage } = upper;
                            this[attacker].lives -= damage;
                            addedState.event = { type: 'spicesHitted' }
                            return { force: force_, ...addedState }
                        }

                    }
                }

                // просчитали uppers - это то, что может быть снято

                if (type === 'armor') {

                    const { armored } = armor;

                    if (armored >= force_) {
                        addedState.event = { type: 'noDamage' }
                        return { force: force_, ...addedState }
                    }

                    this[target].lives -= (force_ - armored);
                    return { force: force_ };
                }

                if (type === 'undamage') {
                    addedState.event = { type: 'noDamage' }
                    return { force: force_, ...addedState }
                }

                if (type === 'usual') {
                    this[target].lives -= force_;
                    return { force: force_ };
                }
            }


        }

        if (race === 'ai') {

            let force_ = 0;
            force_ = force;

            this[target].lives -= force_;
            return { force: force_ };
        }
    }


    startNewTurn = () => {
        this.nowMoveNumber++;
        this.nowBlockMoveNumber++;

        if (this.nowBlockMoveNumber > this.NowBlock.length) {
            this.nowBlockMoveNumber = 1;

            const {
                scheme, // [1, 2, 2]
                type
            } = this.InnerBlock

            let newBlock = null;

            if (!type || type === 'usual' || !newBlock) {
                this.NowBlock = scheme;
            }

        }
        this.messageEndpoint(NEW_TURN)

    }
}